<template>
  <div class="toasts-wrapper" v-if="toasts.length">
    <Toast
      v-for="(toast, index) of toasts"
      :key="index"
      :toast="toast"
      />
  </div>
</template>
<script>
import Toast from '@/components/Toast.vue';

export default {
  name: 'ToastsView',
  components: { Toast, },
  computed: {
    toasts() {
      return this.$store.state.toast.toasts;
    }
  }
}

</script>
<style>
.toasts-wrapper {
  width: 600px;
  min-height: 150px;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: fixed;
  right: 1em;
  top: 1rem;
  z-index: 41;
}
</style>